<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li class="menu-title"><b v-if="agency">{{ agency.name }}</b><br>Navigation</li>

      <li v-if="checkPermission(['F_SELF_CV'])">
        <router-link tag="a" class="waves-effect" to="/app/self-cv/general-data">
          <i class="fe-user-plus"></i>
          <span> CV </span>
        </router-link>
      </li>
      <li v-if="checkPermission(['F_SELF_CV'])">
        <router-link tag="a" class="waves-effect" to="/app/self-cv/apply-selection-process-list">
          <i class="fe-user-check"></i>
          <span> Apply Selection Process </span>
        </router-link>
      </li>
      <li v-if="!checkPermission(['F_SELF_CV', 'F_SELECTION_PROJECT'])">
        <router-link tag="a" class="waves-effect" to="/app/dashboard">
          <i class="fe-home"></i>
          <span> Dashboard </span> 
        </router-link>
      </li>
      <li v-if="checkPermission(['F_SEARCH', 'F_SELECTION_PROJECT'])">
        <router-link tag="a" class="waves-effect" to="/app/search-candidate">
          <i class="fe-search"></i>
          <span> Search </span>
        </router-link>
      </li>
      <li v-if="checkPermission(['F_SELECTION_PROCESS'])">
        <router-link tag="a" class="waves-effect" to="/app/selection-process">
          <i class="fe-user-check"></i>
          <span> Selection Process </span>
        </router-link>
      </li>
      <li v-if="checkPermission(['F_SELECTION_PROJECT'])">
        <router-link tag="a" class="waves-effect" to="/app/selection-process/project">
          <i class="fe-user-check"></i>
          <span> Selection Process </span>
        </router-link>
      </li>
      <li v-if="checkPermission(['F_CANDIDATE_AGENCY'])">
        <router-link tag="a" class="waves-effect" to="/app/candidate/general-data">
          <i class="fe-user-plus"></i>
          <span> Add </span>
        </router-link>
      </li>
      <li v-if="checkPermission(['F_CONFIG_AGENCY', 'F_USER_AGENCY'])">
        <a href="javascript: void(0);" aria-expanded="false" class="has-dropdown">
          <i class="fe-settings"></i>
          <span> Settings </span>
          <span class="menu-arrow"></span>
        </a>
        <ul class="nav-second-level" aria-expanded="false">
          <li v-if="checkPermission(['F_USER_AGENCY'])">
            <router-link tag="a" class="waves-effect" to="/app/settings-users">Users</router-link>
          </li>
          <li v-if="checkPermission(['F_CONFIG_AGENCY'])">
            <router-link tag="a" class="waves-effect" to="/app/settings-fields">Mandatory Fields</router-link>
          </li>
          <li v-if="checkPermission(['F_CONFIG_AGENCY'])">
            <router-link tag="a" class="waves-effect" to="/app/settings-aoe">Areas of Expertise</router-link>
          </li>
          <!--
          <li>
            <router-link tag="a" class="waves-effect" to="/app/settings-agency">Agency</router-link>
          </li> -->
        </ul>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>

<script>
import { authComputed } from '@state/helpers'

import MetisMenu from 'metismenujs/dist/metismenujs'

export default {
  components: {},
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  computed: {
    ...authComputed,
  },
  mounted: function() {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu('#side-menu')
    var links = document.getElementsByClassName('waves-effect')
    var matchingMenuItem = null
    for (var i = 0; i < links.length; i++) {
      if (window.location.pathname === links[i].pathname) {
        matchingMenuItem = links[i]
        break
      }
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active')
      var parent = matchingMenuItem.parentElement

      if (parent) {
        
        parent.classList.add('active')

        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.add('mm-show')
        }

        const parent3 = parent2.parentElement

        if (parent3.localName === 'li') {
          parent3.classList.add('active')
          var childAnchor = parent3.querySelector('.has-dropdown')
          if (childAnchor) childAnchor.classList.add('active')
        }
      }
    }
  },
  methods: {
    checkPermission(roles) {
      return roles.some((r) => this.user.userRoles.includes(r))
    }
  }
}
</script>

<style lang="scss">
@import '~metismenujs/scss/metismenujs';
</style>
